import { artUrl } from "../lib/artVersion";

/**
 * 🤔 **「잠깐 안 돼요」 그림** — 고개를 갸웃하는 그레그 (2026-09-27 · 조치계획서 ■1).
 *
 * 마을·책·카드를 못 불러오거나 카드가 아직 준비 중일 때, 아이 화면은 **글자만** 말했다.
 * 4~7세는 그 글을 못 읽는다 — 빈 화면인지, 기다리면 되는지, 고장인지 알 수가 없다.
 * 그림 한 장이 「지금은 안 되는구나」를 대신 말한다. 글은 그대로 둔다(보호자가 읽는다).
 *
 * · 실패할 때만 그려진다 — 평소에는 받지 않는다(조치계획서 ■2 요청 수에 안 잡힌다)
 * · 그림 안에 글자가 없고 옆의 글이 뜻을 말하므로 스크린리더에는 숨긴다(`alt=""`)
 * · 그레그가 흰색이라 흰 배경을 오려 내면 몸까지 사라진다 — 크림 바탕째 둥근 카드로 쓴다
 * · 원본 1024px: `assets-src/ui/state/oops.webp`
 */
export function KidOops({ size = 112, className = "" }: { size?: number; className?: string }) {
  return (
    <img
      className={`kid-oops ${className}`.trim()}
      src={artUrl("/art/ui/state/oops.webp")}
      width={size}
      height={size}
      alt=""
      decoding="async"
    />
  );
}
